import React from "react";
import i18n from "utils/i18n";
import _ from 'lodash'
import ThemedBlock from 'components/atoms/ThemedBlock'
import Form, { createTranslationField } from 'components/molecules/Form'
import HelperManagementRights from 'utils/helper-management-rights'
import { managementRightsConstants } from 'utils/constants/management-right-constants'
import { useSelector } from 'react-redux'
import { dataConstants } from 'services/redux/data/constants'
import { FormFieldsConstants, FormStatus } from 'utils/constants/form-constants'
import PreviewTimeslotKind from 'scenes/management/timeslots/timeslot_kind/_components/PreviewTimeslotKind'
import VStack from 'components/atoms/stack/VStack'
import ThemedLayout from "components/atoms/ThemedLayout";
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import { useShowHamburger } from "utils/helper-device";
import GraphqlBuilder, { graphqlOptions } from "utils/request/graphql/builder";
import MutateTranslation from "utils/mutate/translation";
import { tableConstants } from "utils/constants/constants";
import { useNavigation, useRoute } from "@react-navigation/native";
import { AppRoutes } from "navigations/app-routes";
import FetchCreditBundles from "utils/fetch/FetchCreditBundles";
import useFetch from "utils/hooks/useFetch";
import MutationManagementTimeslotKind from "graphql/mutations/management/MutationManagementTimeslotKind";
import MutationManagementCreditBundle from "graphql/mutations/management/MutationManagementCreditBundle";
import useRouteParameters from "utils/hooks/use-route-parameters";
import Translate from "utils/translate";
import MutationManagementQrCode from "graphql/mutations/management/MutationManagementQrCode";
import MutationManagementCreditQrCode from "graphql/mutations/management/MutationManagementCreditQrCode";
import FetchCreditQrCodes from "utils/fetch/FetchCreditQrCodes";
import { openUrl } from "utils/helper-url";
import { configClient } from "components/provider/ConfigProvider";
import Button from "theme/Button";
import Text from "theme/Text";

const ManagementCreditQrEdit = ( { updateTimeslotKind, timeslotKind, isSaving }) => {

	const route = useRoute();
	const _routeParameters = useRouteParameters( route );

	const navigation = useNavigation();
	const showHamburger = useShowHamburger();

	const _languages = useSelector( state => {
		return state.data[dataConstants.LANGUAGES];
	} )
	const _timeslotKinds = useSelector(state => {
		return state.data[dataConstants.TIMESLOT_KINDS];
	} );

    const { data: creditQrCode, loading, refetch } = useFetch( FetchCreditQrCodes.fetch, {
		variables: {
			guid: _routeParameters?.guid
		}
	} );

	const onPressDownloadPDF = ( item ) => {
		const type = 'a4';
		const url = configClient.url() + `/connection/rest/pdf/generate/type/${type}/guid/creditqr:${ item.guid }`;

		openUrl( url, '_blank' );
	}

	const saveForm = ( values, { callback } = {} ) => {
		new GraphqlBuilder( { [ graphqlOptions.processVariables ]: false })
			.addQuery( 'mutation', MutationManagementCreditQrCode, values )
			.setResultPath( ['mutation', 'credit_qr_code'], {} )
			.setOnStart( () => {
				callback( FormStatus.LOADING )
			})
			.setOnSuccess( ( result ) => {
				if( _.get( timeslotKind, 'guid' ) !== result.guid ){
					navigation.replace( AppRoutes.MANAGEMENT_CREDIT_BUNDLES_QR_EDIT, {
						guid: result.guid,
					});
				}else{
					refetch()
				}
			})
			.setOnError( ( result ) => {
				callback( FormStatus.ERROR )
			})
			.execute()
	}
	
	const formFields = [
		{
			name: 'name',
			label: i18n.t('management:form.name.system_name'),
			type: FormFieldsConstants.TEXT,
		},
		{
			name: 'credits_amount',
			label: i18n.t('management:form.credit_amount.title'),
			type: FormFieldsConstants.NUMBER,
		},
		{
			name: 'price',
			label: i18n.t('management:form.price.title'),
			type: FormFieldsConstants.NUMBER,
		},
		{
			name: 'timeslot_kind_guid',
			label: i18n.t('management:form.timeslot_kinds.title'),
			type: FormFieldsConstants.SELECT,
			options: _.map( _timeslotKinds, ( timeslotKind ) => {
				return {
					value: timeslotKind.guid,
					label: timeslotKind.name
				}
			})
		},
		{
			name: 'status',
			label: i18n.t('management:form.status.title'),
			type: FormFieldsConstants.SELECT,
			options: [
				{ value: 'active', label: i18n.t('management:form.status.active') },
				{ value: 'inactive', label: i18n.t('management:form.status.inactive') },
			]
		},
	];
	
	return (
		<ThemedSafeAreaComponentTop
			top={ false }>
			
			<ThemedLayout
				title={ i18n.t( 'management:pages.qrcodes.index.title')}
				topNavigation={true}
				topNavigationProps={{
					showHamburgerDrawer: showHamburger
				}}>

				{ !loading && (
					<VStack>
						<ThemedBlock
							shadow
							mediumPadding>
							
							<Form
								values={{
									...creditQrCode,
									timeslot_kind_guid: _.get( creditQrCode, 'timeslot_kind.guid', '' ),
									credits_amount: _.get( creditQrCode, 'credit_bundle.credits_amount', 0 ),
									price: _.get( creditQrCode, 'credit_bundle.price', 0 ),
								}}
								fields={ formFields }
								onChange={ updateTimeslotKind }
								onSubmit={ saveForm }
								disabled={ !HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.TIMESLOTS ) || isSaving }
								forceSaveButton={ true }
							/>
						</ThemedBlock>

							
						{ creditQrCode && (
							<ThemedBlock
								shadow
								mediumPadding>

								<VStack>
									<Text>{ i18n.t(`management:pages.credits.generate_text`) }</Text>

									<Button
										onPress={ onPressDownloadPDF.bind( this, creditQrCode ) }>
										
										{ i18n.t(`management:pages.credits.generate_file`) }
									</Button>
								</VStack>
							</ThemedBlock>
						)}
					</VStack>
				)}
			</ThemedLayout>
		</ThemedSafeAreaComponentTop>
	);
}

export default ManagementCreditQrEdit
